var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"header"},[_c('div',{staticClass:"header-font"},[_vm._v("木棉树机房3D可视化平台")]),_c('div',{staticClass:"time"},[_vm._v(_vm._s(this.nowData)+" "+_vm._s(this.nowTime))])])}
var staticRenderFns = []

export { render, staticRenderFns }